import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import globalReducer from "state/index"
import { Provider } from 'react-redux';
import { setupListeners } from "@reduxjs/toolkit/query"
import { api } from "state/api"
import authReducer from "state/authSlice"
import { installAccountSaver } from "state/savedAccounts"
import { registerServiceWorker } from "./pwa/registerServiceWorker"
import { initNativeShell, isNativeApp } from "./native"

const store = configureStore({
  reducer: {
    global: globalReducer,
    [api.reducerPath]: api.reducer,
    auth: authReducer
  },
  middleware: (getDefault) => getDefault().concat(api.middleware)
})
setupListeners(store.dispatch)
// Every account signed in on this device, for the account switcher.
installAccountSaver(store)

// Capture the Android "add to home screen" opportunity as early as possible so
// the /get-app page can offer one-tap install even if the event fired before
// that route mounted. The page reads window.__deferredInstallPrompt.
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__deferredInstallPrompt = e;
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// The native shell serves its own assets and has no web-push channel, so the
// service worker only earns its keep in the browser/PWA. Registering it inside
// the app would add a second, stale-prone asset cache for no benefit.
if (!isNativeApp()) {
  registerServiceWorker();
}

initNativeShell();

// App-icon badge: the service worker sets a flag-badge on each incoming push;
// once the app is open, components/NotificationsBell.jsx keeps the badge in
// sync with the REAL unread count (and clears it only at zero). The old
// clear-on-focus listener lived here — removed because it wiped the badge
// even while unread notifications remained.